<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useVersionStore } from '@/stores/useVersionStore';
import { useVersion } from '@/composables/useVersion';
import BaseButton from './BaseButton.vue';
import BaseIcon from './BaseIcon.vue';

const { isBlocked, isOutdated, noticeDismissed } = storeToRefs(useVersionStore());
const { syncApiVersion, reload } = useVersion();

syncApiVersion();
</script>

<template>
  <div
    v-if="isBlocked"
    class="fixed inset-0 z-2000 bg-sand-950/60 flex items-center justify-center px-6"
  >
    <div
      class="bg-white rounded-2xl shadow-lg p-10 w-full max-w-sm flex flex-col items-center gap-6 text-center"
    >
      <BaseIcon name="rocket_launch" class="text-6xl text-mint-500 pointer-events-none" />
      <div>
        <p class="text-2xl font-semibold text-sand-800">A new Tahani is ready</p>
        <p class="text-sand-500 mt-1">
          This tab is running an older version of Tahani. Refresh to get the latest changes.
        </p>
      </div>
      <BaseButton label="Refresh Tahani" @click="reload" />
    </div>
  </div>

  <div v-else-if="isOutdated" class="fixed inset-x-0 bottom-0 z-1000 flex justify-center p-4">
    <div
      class="bg-white rounded-xl shadow-lg border border-sand-200 px-5 py-4 flex items-center gap-4 w-full max-w-md"
    >
      <BaseIcon name="rocket_launch" class="text-2xl text-mint-500 pointer-events-none" />
      <div class="flex-1">
        <p class="font-semibold text-sand-800 text-sm">Tahani was updated</p>
        <p class="text-sand-500 text-sm">
          Some things may not work properly. Refresh to get the latest changes.
        </p>
      </div>
      <div class="flex items-center gap-2">
        <BaseButton
          label="Later"
          severity="secondary"
          variant="text"
          :fluid="false"
          @click="noticeDismissed = true"
        />
        <BaseButton label="Refresh" :fluid="false" @click="reload" />
      </div>
    </div>
  </div>
</template>
